import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useMediaQuery } from "react-responsive";
import { ChevronBackwardIcon } from "@jti/brand-icons/chevron-backward";
import { BREAKPOINT_SMALL_LARGE } from "@jti/fe-common";
import { Button } from "../../../../../../components/Button";
import { useDrawer } from "../../../../../../components/Drawer/providers";
import { useStoreLocatorContext } from "../../../../../../components/StoreLocator/hooks";
import { useBodyScrollLock } from "../../../../../../hooks/useBodyScrollLock";
import { useTranslations } from "../../../../../../providers/useTranslations";
import { StoreLocatorFilterButton } from "../../../StoreLocatorFilterButton";
import { StoreLocatorFiltersAll } from "./StoreLocatorFiltersAll";
import styles from "./StoreLocatorFiltersMobile.module.scss";
export const StoreLocatorFiltersMobile = ({ applyFilters, changeFilters, checkFiltersStatus, }) => {
    const isTablet = useMediaQuery({ minWidth: BREAKPOINT_SMALL_LARGE });
    const bodyRef = useRef(null);
    const { __ } = useTranslations();
    const { selectedFiltersNumber } = useStoreLocatorContext();
    const { toggleScroll } = useBodyScrollLock();
    const { isOpen, closeDrawer, openDrawer } = useDrawer();
    useLayoutEffect(() => {
        bodyRef.current = document.body;
    }, []);
    useEffect(() => {
        toggleScroll(isOpen);
    }, [isOpen, toggleScroll]);
    const handleToggleFilters = () => {
        isOpen ? closeDrawer() : openDrawer();
    };
    const handleApplyFilters = () => {
        applyFilters();
        closeDrawer();
    };
    return (_jsxs("div", { children: [_jsx(StoreLocatorFilterButton, { isFiltersAvailable: true, isFiltersOpened: isOpen, onToggleFilters: handleToggleFilters, selectedFiltersNumber: selectedFiltersNumber }), isOpen &&
                bodyRef.current &&
                createPortal(_jsxs("div", { className: styles.filtersMobileWrapper, children: [_jsx("div", { className: styles.filtersHeaderContainer, children: _jsxs("button", { className: styles.filtersHeaderButton, onClick: handleToggleFilters, children: [_jsx(ChevronBackwardIcon, {}), _jsx("h2", { children: __("headerlinks.button.findstore") })] }) }), _jsx(StoreLocatorFiltersAll, { changeFilters: changeFilters, checkFiltersStatus: checkFiltersStatus }), _jsx("div", { className: styles.filterButtonContainer, children: _jsx(Button, { color: "primary", size: isTablet ? "medium" : "small", onClick: handleApplyFilters, "data-testid": "storeLocatorShowFilters", children: __("storelocator.all_filters.show_button") }) })] }), bodyRef.current)] }));
};
//# sourceMappingURL=StoreLocatorFiltersMobile.js.map